import { apiFetch } from './api';

/**
 * « Mot de passe oublié » — appels propres à ce parcours (functions/api/mot-de-passe-oublie.js).
 * Dans un fichier à part plutôt que dans api.ts, que la branche d'intégration modifie aussi.
 */

/** Message affiché après CHAQUE demande, que le compte existe ou non. Ne jamais le faire varier. */
export const MESSAGE_DEMANDE = 'Si un compte correspond à cette adresse, un e-mail vient de vous être envoyé.';

export const motDePasseOubliApi = {
    demander: (email: string) => apiFetch('/mot-de-passe-oublie/demande', { method: 'POST', body: JSON.stringify({ email }) }),
    verifierLien: (token: string) => apiFetch(`/mot-de-passe-oublie/lien/${encodeURIComponent(token)}`),
    choisir: (token: string, motDePasse: string) =>
        apiFetch(`/mot-de-passe-oublie/lien/${encodeURIComponent(token)}`, { method: 'POST', body: JSON.stringify({ motDePasse }) }),
};

export const emailMotDePasseOubliAdminApi = {
    lire: () => apiFetch('/mot-de-passe-oublie/reglages'),
    enregistrer: (payload: any) => apiFetch('/mot-de-passe-oublie/reglages', { method: 'PUT', body: JSON.stringify(payload) }),
    apercu: (payload: any) => apiFetch('/mot-de-passe-oublie/apercu', { method: 'POST', body: JSON.stringify(payload) }),
    tester: (payload: any) => apiFetch('/mot-de-passe-oublie/test', { method: 'POST', body: JSON.stringify(payload) }),
};

/** La règle du nouveau mot de passe — la même que problemeMotDePasse() côté serveur. */
export const MOT_DE_PASSE_MIN = 10;
export const MOT_DE_PASSE_MAX = 200;
export const exigencesMotDePasse = (mdp: string) => [
    { texte: `Au moins ${MOT_DE_PASSE_MIN} caractères`, ok: mdp.length >= MOT_DE_PASSE_MIN },
    { texte: 'Au moins une lettre', ok: /\p{L}/u.test(mdp) },
    { texte: 'Au moins un chiffre', ok: /[0-9]/.test(mdp) },
    { texte: `${MOT_DE_PASSE_MAX} caractères au plus`, ok: mdp.length > 0 && mdp.length <= MOT_DE_PASSE_MAX },
];

const CARACTERES_DE_CONTROLE = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/;
const A_DES_BALISES = /<\s*\/?\s*[a-zA-Z!?]/;

/** Les mêmes contrôles que le serveur (problemeTexte), pour signaler une faute dès la frappe. Le serveur reste juge. */
export const problemeTexteEmail = (champ: string, valeur: string, max: number): string | null => {
    if (!valeur) return null;
    if (max && valeur.length > max) return `Ce texte est trop long (${max} caractères au maximum).`;
    if (CARACTERES_DE_CONTROLE.test(valeur)) return 'Ce texte contient des caractères non autorisés.';
    if (A_DES_BALISES.test(valeur)) return 'Le texte est du texte simple : les balises HTML ne sont pas acceptées.';
    if (['subject', 'button_label', 'sender_name'].includes(champ) && /[\r\n]/.test(valeur)) return 'Ce champ tient sur une seule ligne.';
    if (champ === 'sender_name' && /["<>@;,\\]/.test(valeur)) return "Le nom d'expéditeur ne peut pas contenir de guillemets, @ ni de ponctuation d'adresse.";
    return null;
};
